const URL_PARAM_DEBUG = 'debug';
export const isDebugMode = (): boolean => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(URL_PARAM_DEBUG) === 'true';
  }
  return false;
};

export type LoggerMethods = {
  log: typeof console.log;
  info: typeof console.info;
  warn: typeof console.warn;
  error: typeof console.error;
};

export const logger: LoggerMethods = {
  log: (...args: any[]) => {
    if (isDebugMode()) {
      console.log(...args);
    }
  },
  info: (...args: any[]) => {
    if (isDebugMode()) {
      console.info(...args);
    }
  },
  warn: (...args: any[]) => {
    if (isDebugMode()) {
      console.warn(...args);
    }
  },
  error: (...args: any[]) => {
    if (isDebugMode()) {
      console.error(...args);
    }
  },
};
